import { Observable } from 'rxjs';

import { UseCase }
from '../../base/use-case';

import { PerfilMenuModel }
from '../../models/configuration/perfil-menu.model';
import { ConfigurationRepository }
from '../../repositories/configuration.repository';
import { DataPerfilMenuEntity } from '../../../data/repositories/configuration/entities/perfil-menu.entity';

export class DeletePerfilMenuUseCase
implements UseCase<DataPerfilMenuEntity,
PerfilMenuModel
> {

    constructor(
        private repository:
        ConfigurationRepository
    ) {}

    execute(
    params: DataPerfilMenuEntity
    ):
    Observable<PerfilMenuModel> {

        return this.repository
            .deletePerfilMenu(
                params
            );
    }
}